// extracted by mini-css-extract-plugin
export default {"loader":"index_loader__zI4RC","dot":"index_dot__qBhsW","dotter":"index_dotter__+ynLO","glow":"index_glow__KFy88"};